const selectMissions = state => state.data.missions

const MissionDataStoreSelectors = {
  missions: selectMissions
}

export default MissionDataStoreSelectors
